import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateTeachingType, ITeachingTypePayload } from "../types";
import { GetTeachingTypes } from "./thunk";
import { ITranslation } from "../../../../types";

const initialState: IInitialStateTeachingType = {
    teachingTypesData: [],
    selectedTeachingIDs: [],
    isLoadingTeachingTypes: false,
    teachingRestoreTypesData: [],
    isViewTeachingTypeRestore: false,
    filteredTeaching: [],
};

const teachingTypeSlice = createSlice({
    name: "teachingType",
    initialState,
    reducers: {
        setTeachingTypes: (state, action: PayloadAction<{ data: ITeachingTypePayload[]; defaultLanguage: string }>) => {
            const { data, defaultLanguage } = action.payload;

            state.teachingTypesData = data;
            state.filteredTeaching = state.teachingTypesData.flatMap(data =>
                data.translations
                    .filter((elem: ITranslation) => elem.slug === defaultLanguage && elem.name)
                    .map((elem: ITranslation) => ({
                        id: data.id,
                        name: elem.name || "",
                        abbreviation: elem.abbreviation || "",
                    }))
            );
        },

        deletedTeachingTypes: (state, action: PayloadAction<number>) => {
            state.teachingTypesData = state.teachingTypesData.filter(elem => elem.id !== action.payload);
        },
        updateTeachingTypes: (state, action: PayloadAction<ITeachingTypePayload>) => {
            const updateData = action.payload;

            state.teachingTypesData = state.teachingTypesData.map((elem: ITeachingTypePayload) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },

        setTeachingRestoreData: (state, action) => {
            state.teachingRestoreTypesData = action.payload;
        },
        setIsViewTeachingTypeRestore: state => {
            state.isViewTeachingTypeRestore = !state.isViewTeachingTypeRestore;
        },

        deletedRestoreTeaching: (state, action: PayloadAction<number>) => {
            state.teachingRestoreTypesData = state.teachingRestoreTypesData.filter(elem => elem.id !== action.payload);
        },
        setSelectedTeachingIDs: (state, action) => {
            state.selectedTeachingIDs = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(GetTeachingTypes.pending, state => {
                state.isLoadingTeachingTypes = true;
            })
            .addCase(GetTeachingTypes.fulfilled, state => {
                state.isLoadingTeachingTypes = false;
            })
            .addCase(GetTeachingTypes.rejected, state => {
                state.isLoadingTeachingTypes = false;
            });
    },
});

export const {
    setTeachingTypes,
    deletedTeachingTypes,
    updateTeachingTypes,
    setSelectedTeachingIDs,
    deletedRestoreTeaching,
    setTeachingRestoreData,
    setIsViewTeachingTypeRestore,
} = teachingTypeSlice.actions;

export default teachingTypeSlice;
